import { LOGIN_TOKEN, REFRESH_TOKEN } from "@/api/constants";
import { ADMIN_FLAG } from "@/store/AuthStore";
import type { AuthTokens } from "@/types/api";

const LEGACY_USER_DATA_KEY = "USER_DATA";

export type LegacyUserData = {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role: string;
  lastActivityAt?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export function getStoredTokens(): AuthTokens | null {
  const token = localStorage.getItem(LOGIN_TOKEN);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);

  if (!token || !refreshToken) {
    return null;
  }

  return { token, refreshToken };
}

export function saveTokens({ token, refreshToken }: AuthTokens): void {
  localStorage.setItem(LOGIN_TOKEN, token);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
}

export function hasLegacyUserData(): boolean {
  return Boolean(localStorage.getItem(LEGACY_USER_DATA_KEY));
}

export function getLegacyUserData(): LegacyUserData | null {
  const userData = localStorage.getItem(LEGACY_USER_DATA_KEY);

  if (!userData) {
    return null;
  }

  try {
    return JSON.parse(userData) as LegacyUserData;
  } catch {
    return null;
  }
}

export function clearStoredTokens(): void {
  localStorage.removeItem(LOGIN_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(LEGACY_USER_DATA_KEY);
  localStorage.removeItem(ADMIN_FLAG);
}
